import { Badge, Group, Skeleton, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { DataGrid, TextSerif } from "@/components/elements";
import { useMarketCar } from "@/services/market/get-market-car";
import { formatNumber } from "@/utils/formatEuro";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type CarDescriptionProps = {
  carId?: string;
  hideProductionData?: boolean;
} & MantineStyleProps;

export const CarDescription: FC<CarDescriptionProps> = ({
  carId,
  hideProductionData = false,
  ...props
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useMarketCar({ carId });

  return (
    <Skeleton visible={isLoading}>
      <Stack {...props} gap="lg">
        {hideProductionData ? (
          <Title order={3}>{t("car.sections.car_description")}</Title>
        ) : (
          <DataGrid
            items={[
              { label: t("car.production_years"), value: data?.production_years || "-" },
              {
                label: t("car.number_of_produced_cars"),
                value: data?.produced_cars ? formatNumber(data.produced_cars) : "-",
              },
            ]}
            title={<Title order={3}>{t("car.sections.car_description")}</Title>}
            cols={2}
          />
        )}
        <TextSerif fz="sm">{data?.description || t("car.no_description")}</TextSerif>
        {data?.event_eligibility?.length && data.event_eligibility.length > 0 && (
          <Stack gap="md">
            <TextSerif fz="sm">{t("car.event_eligibility")}</TextSerif>
            <Group mt="xs">
              {data?.event_eligibility?.map((event, idx) => (
                <Badge key={idx} variant="light">
                  {event}
                </Badge>
              ))}
            </Group>
          </Stack>
        )}
      </Stack>
    </Skeleton>
  );
};
